(function () {
  'use strict';

  // ─── Gallery slider ───
  const track = document.getElementById('GalleryTrack');
  if (track) {
    const slides = track.querySelectorAll('.gallery__slide');
    const total = slides.length;
    const thumbs = document.querySelectorAll('.gallery__thumb');
    const dots = document.querySelectorAll('.gallery__dot');
    const main = document.getElementById('GalleryMain');
    let i = 0;

    function go(n, anim = true) {
      if (total === 0) return;
      i = ((n % total) + total) % total;
      if (!anim) track.classList.add('no-anim');
      track.style.transform = `translateX(-${i * 100}%)`;
      if (!anim) requestAnimationFrame(() => track.classList.remove('no-anim'));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    }

    const prev = document.getElementById('GalleryPrev');
    const next = document.getElementById('GalleryNext');
    prev?.addEventListener('click', () => go(i - 1));
    next?.addEventListener('click', () => go(i + 1));
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));

    if (main) {
      main.tabIndex = 0;
      main.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
      });

      // Touch swipe
      let startX = 0, dx = 0, dragging = false;
      main.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX; dx = 0; dragging = true;
        track.classList.add('no-anim');
      }, { passive: true });
      main.addEventListener('touchmove', (e) => {
        if (!dragging) return;
        dx = e.touches[0].clientX - startX;
        track.style.transform = `translateX(calc(-${i * 100}% + ${dx}px))`;
      }, { passive: true });
      main.addEventListener('touchend', () => {
        track.classList.remove('no-anim');
        if (!dragging) return;
        dragging = false;
        const threshold = main.offsetWidth * 0.18;
        if (dx > threshold) go(i - 1);
        else if (dx < -threshold) go(i + 1);
        else go(i);
      });

      // Mouse drag (desktop)
      let mDown = false;
      main.addEventListener('mousedown', (e) => {
        if (e.target.closest('button')) return;
        mDown = true; startX = e.clientX; dx = 0;
        track.classList.add('no-anim');
        main.style.cursor = 'grabbing';
      });
      window.addEventListener('mousemove', (e) => {
        if (!mDown) return;
        dx = e.clientX - startX;
        track.style.transform = `translateX(calc(-${i * 100}% + ${dx}px))`;
      });
      window.addEventListener('mouseup', () => {
        if (!mDown) return;
        track.classList.remove('no-anim');
        mDown = false;
        main.style.cursor = '';
        const threshold = main.offsetWidth * 0.15;
        if (dx > threshold) go(i - 1);
        else if (dx < -threshold) go(i + 1);
        else go(i);
      });
    }
  }

  // ─── Variant picker ───
  // Reads variant JSON from the PDP <script type="application/json" id="ProductData">
  // Updates: selected option pills, price block, add-to-cart label/state, hidden variant id, URL
  const dataEl = document.getElementById('ProductData');
  if (dataEl) {
    const product = JSON.parse(dataEl.textContent);
    const moneyFormat = dataEl.dataset.moneyFormat || '€{{amount}}';
    const variantIdInput = document.getElementById('VariantId');
    const priceEl = document.querySelector('.details__price');
    const priceOldEl = document.querySelector('.details__price-old');
    const saveEl = document.querySelector('.details__save');
    const addBtn = document.getElementById('AddToCart');

    function formatMoney(cents) {
      const amount = Math.abs((cents || 0) / 100);
      function withSeparators(decimals, thousands, decimal) {
        const parts = amount.toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimal);
      }
      // Ersetzt ALLE gängigen Shopify-Money-Format-Tokens, nicht nur {{amount}}.
      // (shop.money_format ist hier {{amount_with_comma_separator}}€ — deutscher Stil.)
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, token) {
        switch (token) {
          case 'amount':                                  return withSeparators(2, ',', '.');
          case 'amount_no_decimals':                      return withSeparators(0, ',', '');
          case 'amount_with_comma_separator':             return withSeparators(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withSeparators(0, '.', '');
          case 'amount_with_apostrophe_separator':        return withSeparators(2, "'", '.');
          default:                                        return withSeparators(2, '.', ','); // deutscher Default
        }
      });
    }

    function readSelected() {
      const selected = [];
      document.querySelectorAll('.variant-options').forEach((group) => {
        const active = group.querySelector('.variant-option.is-active');
        selected.push(active ? active.dataset.value : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return product.variants.find((v) =>
        v.options.every((opt, idx) => opt === selected[idx])
      );
    }

    function update() {
      const selected = readSelected();
      const variant = findVariant(selected);

      // Update current value labels
      document.querySelectorAll('.variant-group').forEach((g, idx) => {
        const cur = g.querySelector('.variant-group__current');
        if (cur && selected[idx]) cur.textContent = selected[idx];
      });

      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Variante nicht verfügbar';
        }
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (priceOldEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceOldEl.textContent = formatMoney(variant.compare_at_price);
          priceOldEl.style.display = '';
          if (saveEl) {
            const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            const save = formatMoney(variant.compare_at_price - variant.price);
            saveEl.textContent = `−${pct}% Spare ${save}`;
            saveEl.style.display = '';
          }
        } else {
          priceOldEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? `In den Warenkorb · ${formatMoney(variant.price)}`
          : 'Ausverkauft';
      }

      // Update URL
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url);
      }

      // Inventar-Anzeige aktualisieren
      const inv = document.getElementById('InventoryIndicator');
      const invText = document.getElementById('InventoryText');
      if (inv && invText) {
        const lowThreshold = parseInt(inv.dataset.lowThreshold) || 10;
        const tracked = variant.inventory_management === 'shopify';
        const qty = variant.inventory_quantity || 0;
        const policy = variant.inventory_policy;
        let state, text;
        if (!variant.available) {
          state = 'sold-out';
          text = 'Ausverkauft';
        } else if (!tracked) {
          state = 'available';
          text = 'Auf Lager · Sofort lieferbar';
        } else if (qty > lowThreshold) {
          state = 'available';
          text = 'Auf Lager · Sofort lieferbar';
        } else if (qty > 0) {
          state = 'low';
          text = `Nur noch ${qty} auf Lager!`;
        } else if (policy === 'continue') {
          state = 'backorder';
          text = 'Auf Vorbestellung — wird nachgeliefert';
        } else {
          state = 'sold-out';
          text = 'Ausverkauft';
        }
        inv.dataset.state = state;
        invText.textContent = text;
        // Urgency-Text dynamisch
        let urgencyEl = inv.querySelector('.inventory__urgency');
        if (state === 'low' && !urgencyEl) {
          urgencyEl = document.createElement('span');
          urgencyEl.className = 'inventory__urgency';
          urgencyEl.textContent = '🔥 Sichere dir deins schnell';
          inv.appendChild(urgencyEl);
        } else if (state !== 'low' && urgencyEl) {
          urgencyEl.remove();
        }
      }

      // Event für Sticky-Add-to-Cart und andere Listener
      document.dispatchEvent(new CustomEvent('variant:changed', {
        detail: {
          variant_id: variant.id,
          available: variant.available,
          formatted_price: formatMoney(variant.price)
        }
      }));
    }

    document.querySelectorAll('.variant-options').forEach((group) => {
      group.querySelectorAll('.variant-option').forEach((opt) => {
        opt.addEventListener('click', () => {
          if (opt.classList.contains('is-disabled')) return;
          group.querySelectorAll('.variant-option').forEach((o) => o.classList.remove('is-active'));
          opt.classList.add('is-active');
          update();
        });
      });
    });
  }

  // ─── Quantity stepper ───
  document.querySelectorAll('[data-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = document.getElementById('Qty');
      if (!input) return;
      const next = Math.max(1, Math.min(99, (parseInt(input.value) || 1) + parseInt(btn.dataset.qty)));
      input.value = next;
    });
  });

  // ─── Add-to-cart (AJAX) ───
  const addBtn = document.getElementById('AddToCart');
  if (addBtn) {
    const form = addBtn.closest('form');
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (addBtn.disabled) return;
        const originalLabel = addBtn.textContent;
        addBtn.textContent = 'Wird hinzugefügt…';
        addBtn.disabled = true;

        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'add to cart failed');
          }

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const cc = document.getElementById('CartCount');
          if (cc) cc.textContent = String(cart.item_count);

          addBtn.textContent = '✓ Im Warenkorb';
          addBtn.classList.add('success');
        } catch (err) {
          addBtn.textContent = 'Fehler — bitte erneut versuchen';
        } finally {
          setTimeout(() => {
            addBtn.textContent = originalLabel;
            addBtn.classList.remove('success');
            addBtn.disabled = false;
          }, 2000);
        }
      });
    }
  }

  // ─── Wishlist toggle (visual only) ───
  document.getElementById('Wishlist')?.addEventListener('click', (e) => {
    e.currentTarget.classList.toggle('is-active');
  });

  // ─── Accordion ───
  document.querySelectorAll('.accordion__head').forEach((head) => {
    head.addEventListener('click', () => {
      head.parentElement.classList.toggle('is-open');
    });
  });

  // ─── Sticky Add-to-Cart (Mobile) ───
  // Erscheint nachdem der Haupt-Add-to-Cart-Button aus dem Viewport scrollt
  const stickyBar = document.getElementById('StickyAtc');
  const mainAtcBtn = document.getElementById('AddToCart');
  const stickyBtn = document.getElementById('StickyAtcBtn');
  const stickyPrice = document.getElementById('StickyAtcPrice');

  if (stickyBar && mainAtcBtn && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        // Wenn Haupt-Button SICHTBAR ist → Sticky verstecken
        // Wenn Haupt-Button NICHT sichtbar (z.B. weil hochgescrollt) → Sticky zeigen
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
          stickyBar.hidden = true;
        } else {
          stickyBar.hidden = false;
          // Nächster Frame damit Transition wirkt
          requestAnimationFrame(() => stickyBar.classList.add('is-visible'));
        }
      },
      { threshold: 0, rootMargin: '0px 0px -20px 0px' }
    );
    io.observe(mainAtcBtn);
  }

  // Klick auf Sticky-Button → triggert echten Form-Submit (gleiche Logik wie Main-Button)
  if (stickyBtn) {
    stickyBtn.addEventListener('click', async () => {
      if (stickyBtn.disabled) return;
      const variantInput = document.querySelector('input[name="id"]');
      const qtyInput = document.getElementById('Qty');
      const variantId = variantInput ? variantInput.value : null;
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      if (!variantId) return;

      const originalLabel = stickyBtn.innerHTML;
      stickyBtn.innerHTML = 'Wird hinzugefügt…';
      stickyBtn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        if (!res.ok) throw new Error('add failed');

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('.cart-count, #CartCount').forEach((el) => (el.textContent = String(cart.item_count)));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, openDrawer: true } }));

        stickyBtn.innerHTML = '✓ Hinzugefügt';
        stickyBtn.classList.add('success');
      } catch (_) {
        stickyBtn.innerHTML = 'Fehler — erneut versuchen';
      } finally {
        setTimeout(() => {
          stickyBtn.innerHTML = originalLabel;
          stickyBtn.disabled = false;
          stickyBtn.classList.remove('success');
        }, 1800);
      }
    });
  }

  // Sticky-Preis live synchron halten wenn Variante wechselt
  document.addEventListener('variant:changed', (e) => {
    if (stickyPrice && e.detail && e.detail.formatted_price) {
      stickyPrice.textContent = e.detail.formatted_price;
    }
    if (stickyBtn && e.detail) {
      stickyBtn.disabled = !e.detail.available;
    }
  });
})();
